import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import * as Cookies from "es-cookie";

import './_studenthome.scss'
import './_homefresh.scss'
import HomeIllustration from './HomeIllustration';
import SubjectCards from './subject_cards/SubjectCards';
import QuickLinks from './fresh/QuickLinks';
import PracticeCard from './practice_cards/PracticeCard';
import ExamsCard from './exams_card/ExamsCard'

import PreparationLifecircle from './preparation_lifecircle/PreparationLifecircle'
import UserRestrictionAlert from "./UserRestrictionAlert";
class StudentHomeSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            getSubjects: props.getSubjects,


            mainindex: 0,
            userRestionModalShow: false,
        }
    }

    startexamFun = (item, modaldata) => {
        if (modaldata == false) {
            localStorage.setItem("sessionid", "0");
            localStorage.setItem("type", "Schedule Exam");
            localStorage.setItem("stype", "schedule_exam");
            localStorage.setItem("exam_paper_id", item.id);
            localStorage.setItem("etype", "schedulehome");

            window.open("/student/subject/exam", "_blank");
        } else {
            this.setState({
                userRestionModalShow: true,
            });
        }
    };
    practceRedirect = (item, modaldata) => {
        //for StudentUserValid
        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }

        const isuserValid = JSON.parse(isStudentUserValid.user_access_restictions);
        const moduleValid = JSON.parse(isStudentUserValid.module_restrictions);


        if ((item.enabled == false && moduleValid.learn_tab == false) || isStudentUserValid.chapter_ids.split(",").includes(item.id.toString())) {

            if (isuserValid.lp_practice_exam == false) {
                let subData = this.props.getSubjects[this.props.stateData.mainindex];
                let totchapters = [];
                this.props.getSubjects.map((item) => {
                    totchapters.push(item.studentChapters);
                });
                let laschapter = totchapters.filter(
                    (a) => a.id == subData.last_attempted_chapter
                );

                localStorage.setItem("subjectid", subData.id);
                localStorage.setItem("type", "practice");
                localStorage.setItem("etype", "homedata");
                localStorage.setItem("chapters", "");
                localStorage.setItem("ocid", item.id);
                localStorage.setItem("otid", "0");
                localStorage.setItem("hchaptername", item.chapter);
                localStorage.setItem("practice_type", 1);
                window.open("/student/subject/practice-test", "_blank"); //to open new page
            }
            else {
                this.setState({
                    userRestionModalShow: true,
                });
            }

        } else {
            this.setState({
                userRestionModalShow: true,
            });
        }
    };
    render() {

        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }

        const isuserValidForCollege = JSON.parse(isStudentUserValid.user_access_restictions);
        const getChapters = this.props.getSubjects[this.props.stateData.mainindex];
        const isuserValid = JSON.parse(
            this.props.isStudentUserValid.user_access_restictions
        );

        // Partner colleges whose students only get the life cycle; other
        // college students see Learn & Practise only at student_userlevel 2.
        const lifecycleOnlyCollege = ["46", "50", "51", "53", "54"].includes(String(isuserValidForCollege.institution_id));
        const showPractice = isuserValidForCollege.userlevel == 1
            ? !lifecycleOnlyCollege && Cookies.get("student_userlevel") == 2
            : true;

        return (
            <section className="student-home home-fresh">
                <HomeIllustration />
                <SubjectCards
                    stateData={this.props.stateData}
                    handleSelect={this.props.handleSelect}
                    getSubjects={this.props.getSubjects} />
                <Row className="home-main-row">
                    {showPractice ? (
                        <Col xs={12} className="my-3 home-col-practice">
                            <PracticeCard
                                practceRedirect={this.practceRedirect}
                                isuserValid={isuserValid}
                                stateData={this.props.stateData}
                                getChapters={getChapters}
                                getSubjects={this.props.getSubjects} />
                        </Col>
                    ) : null}
                    <Col xs={12} className={`my-3${showPractice ? " home-col-lifecycle" : ""}`}>
                        <PreparationLifecircle />
                    </Col>

                    <ExamsCard
                        stateData={this.props.stateData}
                        isuserValid={isuserValid}
                        startexamFun={this.startexamFun}
                        studentGlobals={this.props.studentGlobals}
                        getSubjects={this.props.getSubjects} />
                </Row>
                <QuickLinks />
                <UserRestrictionAlert
                    show={this.state.userRestionModalShow}
                    onHide={() => this.setState({ userRestionModalShow: false })}
                />
            </section>
        )
    }
}

export default StudentHomeSection
